export default __webpack_public_path__ + "static/media/projectfeature3.a53176e5.png";